import ga4 from "@/lib/tracking/ga4Core";

const FOOTER_JOURNEY = "rnpl_service_from_footer";
const JOURNEY_DETAILS = "rent_now_pay_later";

export const trackRNPLFooterClick = ({ listingType, category, source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: "rnpl_footer_button",
    listing_type: listingType,
    property_category: category,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLStartFromFooter = ({ listingType, category, source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: "rnpl_service_start",
    listing_type: listingType,
    property_category: category,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLLearnMoreFromFooter = ({
  listingType,
  category,
  source,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: "learn_more_rnpl_service",
    listing_type: listingType,
    property_category: category,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLAvailableListingsFromFooter = ({
  listingType,
  category,
  source,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: "seek_available_listing",
    listing_type: listingType,
    property_category: category,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLFooterGenericClick = ({
  listingType,
  category,
  source,
  type,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: type,
    listing_type: listingType,
    property_category: category,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLSendPropertyDetails = ({
  listingType,
  category,
  source,
  commission,
  deposit,
  services_fees,
  yearly_price,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: "send_property_details",
    listing_type: listingType,
    property_category: category,
    source,
    input_data: [yearly_price, services_fees, commission, deposit]
      .filter(Boolean)
      .join(":"),
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLSendRNPLAbility = ({
  listingType,
  category,
  source,
  tenant_monthly_income,
  tenant_total_obligations,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: FOOTER_JOURNEY,
    target: category ? `send_btn_for_rental_${category}` : "send_rnpl_ability",
    listing_type: listingType,
    property_category: category,
    source,
    input_data: [tenant_monthly_income, tenant_total_obligations]
      .filter(Boolean)
      .join(":"),
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

const sharedRNPLTracker = ({ target, source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: JOURNEY_DETAILS,
    target,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackRNPLRentNow = ({ source }) => {
  sharedRNPLTracker({
    target: "rent_now",
    source,
  });
};

export const trackRNPLProviderDescription = ({ provider, source }) => {
  sharedRNPLTracker({
    target: `${provider.toLowerCase()}_description`,
    source,
  });
};

export const trackRNPLLearnService = ({ source }) => {
  sharedRNPLTracker({
    target: "learn_more_about_the_service",
    source,
  });
};

export const trackRNPLStart = ({ source }) => {
  sharedRNPLTracker({
    target: "start_now",
    source,
  });
};

export const trackRNPLProviderInit = ({ provider, source }) => {
  sharedRNPLTracker({
    target: `${provider.toLowerCase()}_initiate`,
    source,
  });
};

export const trackRNPLProviderConfirm = ({ provider, source }) => {
  sharedRNPLTracker({
    target: `${provider.toLowerCase()}_confirm`,
    source,
  });
};

export const trackRNPLProviderFollowup = ({ provider, source }) => {
  sharedRNPLTracker({
    target: `${provider.toLowerCase()}_follow_up`,
    source,
  });
};

export const trackRNPLViewInteraction = ({ source }) => {
  const eventName = "view_interaction";
  const eventParams = {
    journey_details: JOURNEY_DETAILS,
    target: "rent_now",
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
